export default __webpack_public_path__ + "static/media/Links-BlankIMGs-05.c08d9a66.jpeg";